<template>
    <div style="width:1300px;margin:0 auto;">
          <div class="card mb-5 p-2" style="box-shadow: 10px 10px 5px #888888;margin-top:100px;">
                    <p style="font-size:0.9rem;">
                    <span class="float-right span_close mr-1" style="display:block;width:20px;line-height:20px;text-align:center;font-size:25px;" @click="$router.go(-1)">
                           &times;
                    </span>
                   </p> 
                   <div class="box">

                      <div id="myChart" :style="{width:'1000px',height:'400px'}">
                                
                      </div>

                   </div>
                   <p>
                      <span class="day">
                        当天
                      </span>
                      <span class="mounth">
                        当月
                      </span>
                   </p>
                   <p class="mt-2" style="font-size:15px;">
                      <span style="margin-left:244px;">
                         流失客户计算方式:
                      </span>
                      <span class="span_time">
                           {{time1}}
                      </span>
                      <span>
                        当天流失客户
                      </span>
                      <span style="margin-left:163px;">
                          流失客户计算方式:
                      </span>
                      <span class="span_time">
                           {{time2}}
                      </span>
                      <span>到</span>
                      <span class="span_time">
                           {{time1}}
                      </span>
                       <span>
                         期间流失的客户
                       </span>
                   </p>
                <div class="mt-5" v-show="showhh">
                        <p class="mt-5 mb-3">
                            <button class="btn btn-info" :class="{active_kan:ryTime==1}" @click="changeTime()">当天</button>
                            <button class="btn btn-info" :class="{active_kan:ryTime==2}" @click="changeTime1()">当月</button>
                            <span style="margin-left:975px;">
                                  <button class="btn btn-info" :class="{active_kan:kankh==1}" @click="getNewcustomer2()">新增客户</button>
                                  <button class="btn btn-info" :class="{active_kan:kankh==2}" @click="getLossingCustomer2()">流失客户</button>
                            </span>
                        </p>
                        <!-- <p style="color:red;" class="mt-2 mb-2 text-center">
                           (数据只最多展示100条)
                        </p> -->
                <table class="table table-striped table-hover sett"  ref="print">
                <thead>
                  <tr style="white-space:nowrap;">
                      <th class="text-center">客户名称</th>
                      <th class="text-center" style="color:red;">客户性质</th>
                      <th class="text-center" style="color:blue;">创建时间/最后采购时间</th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="(item,index) in kehuList" :key="index" style="white-space:nowrap;">
                      <td class="text-center">{{item.customerName}}</td>
                      <td class="text-center" style="color:red;">{{item.customerType}}</td>
                      <td class="text-center" style="color:blue;">{{item.createDate | formatUTC}}</td>
                </tr>
                </tbody>
              </table>



                 <div v-show="ryTime==1&&kankh==1">
                       <v-pagination :total="total" :current-page.sync='current' @pagechange="pagechange" :display="display"></v-pagination>
                </div>
                 <div v-show="ryTime==1&&kankh==2">
                       <v-pagination :total="total1" :current-page.sync='current1' @pagechange="pagechange1" :display="display1"></v-pagination>
                </div>
                
                 <div v-show="ryTime==2&&kankh==1">
                       <v-pagination :total="total" :current-page.sync='current2' @pagechange="pagechange2" :display="display2"></v-pagination>
                </div>

                 <div v-show="ryTime==2&&kankh==2">
                       <v-pagination :total="total1" :current-page.sync='current3' @pagechange="pagechange3" :display="display3"></v-pagination>
                </div> 
                
                    
              </div>
          </div>
    </div>
</template>

<script>
 import vPagination from "../../components/Pagination.vue"
export default {
       data(){
           return{
               Record1:'',
               Record2:'',
               data1:'',
               data2:'',
               time1:'',
               time2:'',
               kehuList:[],
               ryTime:"1",
               kankh:"1",
               total:1,     // 记录总条数
               display:100,
               current: 1, 
                             // 当前的页数
               total1:1,
               display1:100,
               current1:1,

                 
               display2:100,
               current2:1,

                
               display3:100,
               current3:1,

               showhh:false,
             
           }  
       },
       components:{
            vPagination,
       },
      filters:{
          
           formatUTC:function(utc_datetime) {
              return utc_datetime.replace(/T/ig,"  ").substring(0,20)
            } ,

      },

       methods:{

         getNewcustomer2(){
              if(this.ryTime==1){
                 this.getNewcustomer1(this.current);
              }
              if(this.ryTime==2){
               this.getNewcustomer1(this.current2);
              }
         },
         getLossingCustomer2(){
               if(this.ryTime==1){
                 this.getLossingCustomer1(this.current1);
              }
              if(this.ryTime==2){
                this.getLossingCustomer1(this.current3);
              }
         },

      pagechange:function(current){  
               this.current=current
               this.getNewcustomer1(current);
                      
       },
     pagechange1:function(current1){
              this.current1=current1
               this.getLossingCustomer1(current1);
         
       },
        pagechange2:function(current2){
              this.current2=current2
              this.getNewcustomer1(current2);
         
       },
        pagechange3:function(current3){
               this.current3=current3
               this.getLossingCustomer1(current3);
         
       },


          //切换当天当月
          changeTime(){
            this.ryTime=1;
             this.getNewcustomer1(this.current);
          },
          changeTime1(){
            this.ryTime=2
           this.getNewcustomer1(this.current2);
          },
          getTime(){
              this.time1 =this.getDay(-30*3);
              this.time2 =this.getDay(-30*6);
          },
          //获取三个月前的时间
          getDay(day) {　　
                var today = new Date();　　
                var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
                today.setTime(targetday_milliseconds); //注意，这行是关键代码
                var tYear = today.getFullYear();　　
                var tMonth = today.getMonth();　　
                var tDate = today.getDate();　　
                tMonth = this.doHandleMonth(tMonth + 1);　　
                tDate = this.doHandleMonth(tDate);　　
                return tYear+"-" + tMonth+"-" + tDate;
            },
             doHandleMonth(month) {　　
                var m = month;　　
                if (month.toString().length == 1) {　　
                    m = "0" + month;　　
                }　　
                return m;
            },
         //画饼状图
        drawLine(){
            // 基于准备好的dom，初始化echarts实例
        let myChart = this.$echarts.init(document.getElementById('myChart'));
            // 绘制图表
        myChart.setOption({
                title: {
        text:"客户分析",
        left: 'center'
    },
    tooltip: {
        trigger: 'item',
        formatter: '{a} <br/>{b} : {c} ({d}%)'
    },
    legend: {
        orient: 'vertical',
        left: 'left',
        data: ["新增客户", '流失客户']
    },
    series: [
        {
            name: '当天',
            type: 'pie',
            radius: '55%',
            center: ['25%', '60%'],
            data: [
                {value:this.Record2, name: '新增客户',itemStyle:{color:"#d48265"}},
                {value:this.Record1, name: `流失客户`,itemStyle:{color:"#91c7ae"}}
            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            },
        },
        {
            name: '当月',
            type: 'pie',
            radius: '55%',
            center: ['75%', '60%'],
            data: [
                {value: this.data2, name: '新增客户',itemStyle:{color:'#d48265'}},
                {value: this.data1, name: '流失客户',itemStyle:{color:'#91c7ae'}}
            ],
            emphasis: {
                itemStyle: {
                    shadowBlur: 10,
                    shadowOffsetX: 0,
                    shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
            }
        },
        //  color:['#CCC','#AFA', '#61a0a8', '#d48265', '#91c7ae','#749f83',  '#ca8622', '#bda29a','#6e7074', '#546570', '#c4ccd3']
        //  {
        //     name: '当年',
        //     type: 'pie',
        //     radius: '55%',
        //     center: ['80%', '60%'],
        //     data: [
        //         {value: 274164.81, name: '新增客户',itemStyle:{color:'yellow'}},
        //         {value: 151533.65, name: '流失客户',itemStyle:{color:'#66e6ed'}}
        //     ],
        //     emphasis: {
        //         itemStyle: {
        //             shadowBlur: 10,
        //             shadowOffsetX: 0,
        //             shadowColor: 'rgba(0, 0, 0, 0.5)'
        //         }
        //     }
        // },

    ]
            });
          
        },
         //新增客户
         getNewcustomer1: async function (PageIndex) {
        const {data: res} = await this.$http.post('Dls/getFun', {
          action:'Newcustomer',
          obj: JSON.stringify({
            PageIndex:PageIndex,
            DateType:this.ryTime,
          })
        })
        // console.log(res)
        if (res.isok) {
          const that =this
            that.kehuList=res.data.rows;
            // console.log(that.kehuList)
            if(that.kehuList.length==0){
              that.showhh=false;
            }else{
                  that.showhh=true;
            }
           
            that.total=res.data.pcount;
            that.kankh="1"
            
        }else {
          alert(res.message)
        }
        
      },
       //流失客户
      getLossingCustomer1: async function (PageIndex) {
        const {data: res} = await this.$http.post('Dls/getFun', {
          action:'LostCustomer',
          obj: JSON.stringify({
            PageIndex:PageIndex,
            DateType:this.ryTime
          })
        })
        // console.log(res)
        if (res.isok) {
          const that=this
            that.kehuList=res.data.rows;
             if(that.kehuList.length==0){
              that.showhh=false;
            }else{
              that.showhh=true;
            }
            
            that.total1=res.data.pcount;
            that.kankh="2"
            
        }else {
          alert(res.message)
        }
      },
         //新增客户
         getNewcustomer: async function (DateType) {
        const {data: res} = await this.$http.post('Dls/getFun', {
          action:'Newcustomer',
          obj: JSON.stringify({
            PageIndex:1,
            DateType,
          })
        })
        // console.log(res)
        if (res.isok) {
          const obj = res.data
       

          if(DateType==1){
            this.Record2 = obj.record
          }
          if(DateType==2){
            this.data2 = obj.record
          }
          this.drawLine()
        }
        else{
          alert(res.message)
        }
        
      },
      //流失客户
      getLossingCustomer: async function (DateType) {
        const {data: res} = await this.$http.post('Dls/getFun', {
          action:'LostCustomer',
          obj: JSON.stringify({
            PageIndex:1,
            DateType,
          })
        })
        // console.log(res)
        if (res.isok) {
          const obj = res.data
          if(DateType==1){
              this.Record1 = obj.record
            }
          if(DateType==2){
              this.data1 = obj.record
          }
          this.drawLine()
        }
        else{
          alert(res.message)
        }
      },
    },
    mounted(){
      this.drawLine();
    },
    created(){
        this.getNewcustomer(1);
        this.getLossingCustomer(1);
        this.getNewcustomer(2);
        this.getLossingCustomer(2);
        this.getTime();
        this.getNewcustomer1(1);
    }
}
</script>

<style scoped>
   .box{
     margin:0 auto;
   }
   .day{
       margin-left:387px;
       font-size:18px;
   }
   .mounth{
     margin-left:470px;
      font-size:18px;
   }
   .span_close:hover{
       color:#3190e8;
 }
 .span_time{
   color:red;
 }
 .active_kan{
      color:red;
 }
</style>



// WEBPACK FOOTER //
// src/pages/manager/NewCustomer.vue